export type Language = 'de' | 'fr';
export const defaultLanguage: Language = 'de';
export const supportedLanguages: Language[] = ['de', 'fr'];

export function storeLanguage(language: Language) {
  if (!supportedLanguages.includes(language)) {
    return;
  }
  window.localStorage.setItem('language', language);
}

export function loadLanguage() {
  return window.localStorage.getItem('language');
}

export function formatPrice(value: number, lang: string, decimals = 2) {
  return value.toLocaleString(`${lang}-CH`, {
    style: 'currency',
    currency: 'CHF',
    minimumFractionDigits: 0,
    maximumFractionDigits: decimals,
  });
}
